module.exports = __webpack_public_path__ + "static/img/4.60271fd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mohu/1/4.png
// module id = x/+3
// module chunks = 0